/**
 * KURTARMA İFADESİNİ GÖSTER VE DOĞRULAT — kurulumda ve "yeni ifade"de ortak.
 *
 * İfade BİR KEZ gösterilir (Worker onu saklamaz; yalnızca sarmalı tutar).
 * Kullanıcı kâğıda yazdığını onaylar, sonra rastgele üç kelimeyi geri yazar
 * (taslak §1.5: "kurulumda ifade zorunlu doğrulatılır"). Geri yazımda
 * büyük/küçük harf ve fazla boşluk önemsiz, ilk dört harf yeter (BIP-39'da
 * ilk dört harf benzersiz) — Worker'ın kuralıyla aynı.
 */

import { M } from "../../dil";
import { useMemo, useState } from "react";
import { Button, Field, InlineError, Notice, TextInput } from "../../ui/primitives";

function ucRastgeleSira(n: number): number[] {
  const secilen = new Set<number>();
  const b = new Uint32Array(1);
  while (secilen.size < 3) {
    crypto.getRandomValues(b);
    secilen.add((b[0] as number) % n);
  }
  return [...secilen].sort((a, c) => a - c);
}

/** Yazılan, beklenen kelimeyle eşleşiyor mu (tam ya da ≥4 harfli önek). */
export function kelimeTutuyor(yazilan: string, beklenen: string): boolean {
  const y = yazilan.trim().toLowerCase();
  return y === beklenen || (y.length >= 4 && y.slice(0, 4) === beklenen.slice(0, 4));
}

export function IfadeGosterVeDogrula({
  kelimeler,
  onDogrulandi,
}: {
  readonly kelimeler: readonly string[];
  readonly onDogrulandi: () => void;
}) {
  const [asama, setAsama] = useState<"goster" | "dogrula">("goster");
  const [yazdim, setYazdim] = useState(false);
  const sira = useMemo(() => ucRastgeleSira(kelimeler.length), [kelimeler]);
  const [cevap, setCevap] = useState<Record<number, string>>({});
  const [hata, setHata] = useState<string | null>(null);

  if (asama === "goster") {
    return (
      <div className="space-y-3">
        <Notice tone="warn" title={M.kilit.ifade.kagidaYazin}>
          <p>{M.kilit.ifade.kagidaYazinMetin}</p>
        </Notice>
        <ol aria-label={M.kilit.kurtarmaIfadesi} className="grid grid-cols-2 gap-x-6 gap-y-1 sm:grid-cols-3">
          {kelimeler.map((k, i) => (
            <li key={i} className="pf-fig text-[14px] text-ink">
              <span className="mr-2 inline-block w-6 text-right text-faint">{i + 1}.</span>
              {k}
            </li>
          ))}
        </ol>
        <label className="flex items-center gap-2 text-[13px] text-ink">
          <input type="checkbox" checked={yazdim} onChange={(e) => setYazdim(e.currentTarget.checked)} />
          {M.kilit.ifade.yazdim}
        </label>
        <Button variant="primary" disabled={!yazdim} onClick={() => setAsama("dogrula")}>
          {M.ortak.devam}
        </Button>
      </div>
    );
  }

  const onDogrula = (): void => {
    const yanlis = sira.find((i) => !kelimeTutuyor(cevap[i] ?? "", kelimeler[i] as string));
    if (yanlis !== undefined) {
      setHata(M.kilit.ifade.tutmadi(yanlis + 1));
      return;
    }
    onDogrulandi();
  };

  return (
    <div className="space-y-3">
      <p className="text-[13px] text-ink">{M.kilit.ifade.dogrulamaAciklama}</p>
      <div className="grid gap-3 sm:grid-cols-3">
        {sira.map((i) => (
          <Field key={i} label={M.kilit.ifade.kelime(i + 1)} htmlFor={`ifade-dogrula-${i}`}>
            <TextInput
              id={`ifade-dogrula-${i}`}
              autoComplete="off"
              autoCapitalize="none"
              spellCheck={false}
              value={cevap[i] ?? ""}
              onChange={(e) => {
                const v = e.currentTarget.value;
                setCevap((c) => ({ ...c, [i]: v }));
                setHata(null);
              }}
            />
          </Field>
        ))}
      </div>
      {hata !== null && <InlineError error={new Error(hata)} />}
      <div className="flex flex-wrap gap-2">
        <Button variant="primary" onClick={onDogrula}>
          {M.kilit.ifade.dogrula}
        </Button>
        <Button
          onClick={() => {
            setAsama("goster");
            setHata(null);
          }}
        >
          {M.kilit.ifade.yenidenGoster}
        </Button>
      </div>
    </div>
  );
}
